






import { Vue, Component } from 'vue-property-decorator';

@Component({ name: 'EmployeesView', components: { } })
export default class Employees extends Vue {
  routerKey: number = 0;

  onRouterViewChange(to: any, from: any) {
    if (to.path !== from.path) {
      this.routerKey += 1;
    }
  }

  created() {
    this.$watch('$route', this.onRouterViewChange);
  }
}
